import { createActions } from 'reduxsauce';
const { Types, Creators } = createActions({
  setLoading: ['isLoadingConfig'],
  setPermissionConfigSuccess: ['permission'],
  getGeneralConfig: [],
  getGeneralConfigSuccess: ['generalConfig'],
  getNotificationConfigSuccess: ['notificationConfig'],
  setSystemConfigSuccess: ['systemConfig'],
  getRoutesConfig: [],
  getNotificationConfig: [],
  getStaticPageConfig: [],
  getStaticPageConfigSuccess: ['landingPageConfig'],
  getNavMenuConfig: ['key', 'label'],
  getNavMenuConfigSuccess: ['navMenuConfig'],
});
export const ConfigTypes = Types;
export default Creators;
